import React from "react";
import Slider from "react-slick";
const MvmSlider = ({ children }) => {
    const arrowWidth = 22;
    const LeftArrow = ({ currentSlide, slideCount, ...props }) => (React.createElement("div", { ...props },
        React.createElement("svg", { width: "22px", height: "40px", fill: "currentColor", viewBox: "0 0 22 40" },
            React.createElement("use", { xlinkHref: "/public/icons/mvm-icons.svg#left-arrow" }))));
    const RightArrow = ({ currentSlide, slideCount, ...props }) => (React.createElement("div", { ...props },
        React.createElement("svg", { width: "22px", height: "40px", fill: "currentColor", viewBox: "0 0 22 40" },
            React.createElement("use", { xlinkHref: "/public/icons/mvm-icons.svg#right-arrow" }))));
    const settings = {
        dots: false,
        arrows: true,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 4,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 984 + arrowWidth * 2,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                },
            },
            {
                breakpoint: 720 + arrowWidth * 2,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2,
                },
            },
            {
                breakpoint: 540 + arrowWidth * 2,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
        prevArrow: React.createElement(LeftArrow, null),
        nextArrow: React.createElement(RightArrow, null),
    };
    return (React.createElement("div", { className: "slider-container" },
        React.createElement(Slider, { ...settings }, children)));
};
export default MvmSlider;
